import { createContext, useContext } from 'react'

type SideNavContextValue = {
  /** The nav is its icon rail: items show their icon, with the label in a tooltip. */
  collapsed: boolean
}

// Outside a SideNav (a story, a flyout) items render expanded.
export const SideNavContext = createContext<SideNavContextValue>({ collapsed: false })

export const useSideNavContext = () => useContext(SideNavContext)
